import styled from "styled-components/macro";
import { borderRadius, breakpoint, colors, space } from "shared/styles/constants";

export const StyledImageGalleryItem = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;

  height: 100%;

  > * + * {
    margin-left: ${space.l};
  }

  ${breakpoint("m", "down")} {
    flex-direction: column;

    > * + * {
      margin-left: 0;
      margin-top: ${space.m};
    }
  }
`;

export const StyledImageContainer = styled.div`
  position: relative;

  display: flex;
  align-items: stretch;
  justify-content: center;

  flex: 1 1 75%;

  [data-loader] {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  ${breakpoint("m", "down")} {
    flex: 1 1 85%;
  }
`;

export const StyledImage = styled.div`
  position: relative;

  overflow: hidden;

  flex: 1 1 75%;

  display: flex;
  align-items: stretch;
  justify-content: center;

  border: 1px solid ${colors.grey2};
  border-radius: ${borderRadius.m};

  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  &:not([data-background]) {
    background-color: ${colors.black};
  }
`;

export const StyledDescription = styled.div`
  flex: 0 0 25%;

  max-height: 100%;
  overflow-y: auto;

  ${breakpoint("m", "down")} {
    flex: 0 0 15%;
  }
`;
